import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/category-accordion-nav.css";

const CategoryAccordionNav = ({
  categories = [],
  departments = [],
  currentCategorySlug = "",
  currentDepartmentSlug = "",
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const [openSlug, setOpenSlug] = useState("");

  useEffect(() => {
    setOpenSlug(currentCategorySlug || "");
    setIsMenuOpen(true);
  }, [currentCategorySlug, currentDepartmentSlug]);

  const departmentsByCategory = useMemo(() => {
    const map = {};

    departments.forEach((dep) => {
      const categoryId =
        typeof dep.category === "object" ? dep.category?._id : dep.category;

      if (!categoryId) return;

      if (!map[categoryId]) map[categoryId] = [];
      map[categoryId].push(dep);
    });

    return map;
  }, [departments]);

  return (
    <div className="cat-accordion-card">
      <div className="cat-accordion-header">
        <span>CATEGORÍAS</span>

        <button
          type="button"
          className="cat-accordion-header-btn"
          onClick={() => setIsMenuOpen((prev) => !prev)}
          aria-label={isMenuOpen ? "Cerrar categorías" : "Abrir categorías"}
        >
          {isMenuOpen ? "−" : "+"}
        </button>
      </div>

      <nav className={`cat-accordion-list ${isMenuOpen ? "open" : "closed"}`}>
        {categories.map((category) => {
          const categoryDepartments = departmentsByCategory[category._id] || [];
          const isOpen = openSlug === category.slug;

          const isActiveCategory =
            currentCategorySlug === category.slug && !currentDepartmentSlug;

          return (
            <div className="cat-accordion-group" key={category._id}>
              <div className="cat-accordion-row">
                <Link
                  to={`/categorias/${category.slug}`}
                  className={`cat-accordion-main-link ${
                    isActiveCategory ? "active" : ""
                  }`}
                >
                  {category.name}
                </Link>

                {categoryDepartments.length > 0 && (
                  <button
                    type="button"
                    className="cat-accordion-toggle"
                    onClick={() =>
                      setOpenSlug((prev) =>
                        prev === category.slug ? "" : category.slug
                      )
                    }
                    aria-label={
                      isOpen ? "Cerrar departamentos" : "Abrir departamentos"
                    }
                  >
                    {isOpen ? "−" : "+"}
                  </button>
                )}
              </div>

              {isOpen && categoryDepartments.length > 0 && (
                <div className="cat-accordion-sublist">
                  {categoryDepartments.map((dep) => {
                    const isActiveDepartment =
                      currentCategorySlug === category.slug &&
                      currentDepartmentSlug === dep.slug;

                    return (
                      <Link
                        key={dep._id}
                        to={`/categorias/${category.slug}/departamento/${dep.slug}`}
                        className={`cat-accordion-sub-link ${
                          isActiveDepartment ? "active" : ""
                        }`}
                      >
                        {dep.name}
                      </Link>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </nav>
    </div>
  );
};

export default CategoryAccordionNav;